export default "__VITE_ASSET__NKdLbJm8__"